export default __webpack_public_path__ + "bd9bf4a5512860e25025e7de6a1f9676.png";